import React from 'react';
import { Grid } from '@mui/material';
import i18n from '../../i18';
import HeaderSection from '../../sections/dashboard/HeaderSection';
import NavigationBoxSection from '../../sections/dashboard/NavigationBoxSection';
import StatsSection from '../../sections/dashboard/StatsSection';
import ChartsSection from '../../sections/dashboard/ChartsSection';

export default class PartnerDashboardContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: props.data
        };
    }

    render() {
        const { data } = this.state;
        const { navigate } = this.props;
        const transactionVolumesByDate = data.transactionVolumesByDate || {};
        const datesLabelsTransactionVolumes =
            data.datesLabelsTransactionVolumes || [];
        const totalActiveWallets = data.totalActiveWallets || 0;
        const statsData = [
            {
                path: '/app/users',
                title: i18n.t('dashboard.totalUsers'),
                subtitle: i18n.t('dashboard.totalUsersSubtitle'),
                total: (data.totalMerchants || 0) + (data.totalPartners || 0),
                gradient: 'primary'
            },
            {
                path: '/app/wallets',
                title: i18n.t('dashboard.totalActiveWallets'),
                subtitle: i18n.t('dashboard.totalActiveWalletsSubtitle'),
                total: totalActiveWallets,
                gradient: 'secondary'
            },
            {
                path: '/app/transactions',
                title: i18n.t('dashboard.totalTransactionsCount'),
                subtitle: i18n.t('dashboard.totalTransactionsCountSubtitle'),
                total: data.totalTransactionsCount || 0,
                gradient: 'info'
            }
        ];
        const headerActions = [
            // {
            //     title: i18n.t('actions.addMerchant'),
            //     subtitle: i18n.t('actions.addMerchantSubtitle'),
            //     icon: <AddCircleWhiteLinearIcon />,
            //     onClick: () => navigate('/app/merchants')
            // }
        ];
        return (
            <Grid container spacing={3}>
                <HeaderSection
                    currentUser={data.currentUser}
                    actions={headerActions}
                />
                <NavigationBoxSection navigate={navigate} />
                <StatsSection statsData={statsData} />
                <ChartsSection
                    transactionVolumesByDate={transactionVolumesByDate}
                    datesLabelsTransactionVolumes={
                        datesLabelsTransactionVolumes
                    }
                />
            </Grid>
        );
    }
}
